import { defineMessages } from 'react-intl';

export default defineMessages({
  removeClaim: {
    id: 'src.pages.RemoveClaimPopUp.removeClaim',
    defaultMessage: 'Remove Claim?',
  },
  areYouSure: {
    id: 'src.pages.RemoveClaimPopUp.areYouSure',
    defaultMessage: 'Are you sure you want to do this? Remember, you won’t be able to return to this claim once you’ve removed it.',
  },
  yesRemove: {
    id: 'src.pages.RemoveClaimPopUp.yesRemove',
    defaultMessage: 'Yes, remove claim',
  },
  cancel: {
    id: 'src.pages.RemoveClaimPopUp.cancel',
    defaultMessage: 'Cancel',
  },
});
